import { render, staticRenderFns } from "./App-admin.vue?vue&type=template&id=d27debd0&scoped=true"
import script from "./App-admin.vue?vue&type=script&lang=js"
export * from "./App-admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27debd0",
  null
  
)

export default component.exports